import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const sections = [
    { label: "Home", href: "#" },
    { label: "Our Vision", href: "#our-vision" },
    { label: "About the Founder", href: "#about-the-founder" },
    { label: "Contact", href: "#tariff-contact-form" },
  ];

  return (
    <div>
      <footer className="bg-gradient-to-br from-main-dark via-gray-800 to-black text-main-light py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
            {/* About Section */}
            <div>
              <h3 className="text-2xl font-bold font-barlow mb-6 border-b-2 border-main-green pb-2">
                About TSE
              </h3>
              <p className="text-gray-400 leading-relaxed">
                The Tariff Stock Exchange (TSE) is the world’s first platform
                built to monetize tariffs, economic disruption, and geopolitical
                shifts—where volatility becomes wealth, and policy becomes
                profit.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-2xl font-bold font-barlow mb-6 border-b-2 border-main-green pb-2">
                Quick Links
              </h3>
              <ul className="space-y-4">
                {sections.map((section, index) => (
                  <li key={index}>
                    <a
                      href={section.href}
                      className="text-gray-400 hover:text-main-green transition duration-300"
                    >
                      {section.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Ecosystem */}
            <div>
              <h3 className="text-2xl font-bold font-barlow mb-6 border-b-2 border-main-green pb-2">
                Ecosystem
              </h3>
              <ul className="space-y-2 mb-4">
                <li>
                  <a
                    href="#what-we-are-building"
                    className="text-gray-400 hover:text-main-green transition duration-300"
                  >
                    What We’re Building
                  </a>
                </li>
                <li>
                  <a
                    href="#who-its-for"
                    className="text-gray-400 hover:text-main-green transition duration-300"
                  >
                    Who It’s For
                  </a>
                </li>
                <li>
                  <a
                    href="#why-now"
                    className="text-gray-400 hover:text-main-green transition duration-300"
                  >
                    Why Now
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div>
              <h3 className="text-2xl font-bold font-barlow mb-6 border-b-2 border-main-green pb-2">
                Contact Us
              </h3>
              <p className="text-gray-400">
                <span className="font-bold">Address:</span>{" "}
                1001 S. MAIN ST. STE 500 KALISPELL,           MT 59901
              </p>
              <p className="text-gray-400">
                <span className="font-bold">Email:</span>{" "}
                info@TariffStockExchange.com
              </p>
              <p className="text-gray-400">
                <span className="font-bold">Phone:</span>   +92 321-9700700
              </p>
              <div className="mt-6 flex space-x-4 justify-center sm:justify-start">
                <a
                  href="https://www.linkedin.com/company/tariffstockexchange/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-main-green hover:text-accent-blue transition"
                >
                  <i className="fab fa-linkedin-in text-2xl"></i>
                </a>
                <a
                  href="https://www.youtube.com/@TariffStockExchange"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-main-green hover:text-accent-blue transition"
                >
                  <i className="fab fa-youtube text-2xl"></i>
                </a>
                <a
                  href="https://www.twitter.com/tariffexchange"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-main-green hover:text-accent-blue transition"
                >
                  <i className="fab fa-twitter text-2xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 border-t border-gray-700 pt-6 text-center">
            <p className="text-gray-500 text-sm">
              &copy; 2024 IOPC. Created by Muhammad Usman. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
